<template >
  
    <div class="login-bg">
    <w-app id="app" class="justify-space-between basis-zero justify-center align-center login-bg">
      <header></header>
      
      <main class="grow align-self-center mt10">
        
        <w-card class="zloginbox-title">

          <!--
          <w-image
            class="zloginbox"
            src="/images/jata-malaysia.svg"
            height="250"
            width="100%"
          ></w-image>
          -->

          <div class="zloginbox-logo">
              <img src="/images/jata-malaysia.svg">
          </div>

          <div class="zloginbox-title-top">SISTEM PENGURUSAN PENTAKSIRAN BERSEPADU</div>
          <div class="zloginbox-title-bottom">Log Masuk ke Sistem SPPB</div>

        </w-card>

        <w-card class="zloginbox">
       
        <template #buttons />

          <w-form
            @validate="attemp"
          >
            <z-input 
              outline
              label="ID Pengguna" 
              placeholder="Sila MAsukan ID Pengguna"  
              name="id"
              v-model="form.id"
              :validators="[validators.required]"
            />
            <div class="spacer"></div>
            <z-input 
              outline
              label="Katalaluan" 
              class="mt5"
              placeholder="Sila MAsukan Katalaluan" 
              type="password" 
              name="password"
              v-model="form.password"
              :validators="[validators.required]"
            />

              <div class="mt5 mb5"></div>

              <w-flex justify-center align-center >
                  <div class="xs6 w-list__item-label--disabled">
                      <w-checkbox>Ingat Saya</w-checkbox>
                  </div>
                  <div class="xs6 text-right w-list__item-label--disabled">
                      <w-icon>fal fa-question-circle</w-icon> Lupa katalaluan?
                  </div>
              </w-flex>

              <w-flex justify-center align-center class="mt5">

                    <!--
                    <w-button
                      class="my1 mr2"
                      bg-color="warning"
                      type="reset">
                      Reset
                    </w-button>
                    -->

                    <w-button
                      class="my2 btn-zloginbox grow"
                      type="submit"
                    >
                      <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> Log Masuk
                    </w-button>

              </w-flex>

          </w-form>
        </w-card>

        <div class="zloginbox-title-footer">
              © 2021 <b>Kementerian Pendidikan Malaysia</b> (KPM)<br>
              Hak Cipta Terpelihara
        </div>

        

      

      </main>

      <footer>
      </footer>
    </w-app>
  
  </div>
</template>


<script>
export default {
  data() {
    return {
      form: {
        id: '',
        password: '' 
      },
      validators: {
          required: value => !!value || 'Medan Ini Wajib'
          // Other validators...
        }
    }
  },
  methods: {
    attemp() {
      this.$inertia.post('login',this.form)
    }
  }
}
</script>

<style>
#app {
  flex-direction: column;
}
.w-app {
    background: url(/images/sppb-login-bg.png) !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
}
.zloginbox {
  width: 420px;
  background: inherit !important;
}
.zloginbox .w-card__content {
    background: #fff;
}
.zloginbox .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}
.zloginbox .w-input__input-wrap {
    margin-top: 25px;
}
.zloginbox .w-input__label--inside {
    font-size: 15px;
    margin-top: -5px;
    margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
    height: 33px;
}
.zloginbox .w-card__content {
    padding: 16px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #3d272ab0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #8c6c68;
    border-left: 1px solid #8c6c68;
    border-right: 1px solid #8c6c68;
    margin-top:150px;
}
.zloginbox-title-top{
    font-weight: bold;
    font-size: 15px;
    text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloginbox-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloginbox{
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 13px !important;
    padding: 15px;
}
.zloginbox-title-footer {
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin-top: 10px;
    text-shadow: 1px 1px black;
}
</style>